import { render, staticRenderFns } from "./DownloadInvoice.vue?vue&type=template&id=58fc84a4&scoped=true"
import script from "./DownloadInvoice.vue?vue&type=script&lang=js"
export * from "./DownloadInvoice.vue?vue&type=script&lang=js"
import style0 from "./DownloadInvoice.vue?vue&type=style&index=0&id=58fc84a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc84a4",
  null
  
)

export default component.exports